export default {
  googleAuthorizeTerms: "이 앱은 2023년 3월 10일부터 지원 중단됩니다. {googleAppName}의 새 버전을 설치하세요."
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
